import React, { useEffect, useContext, useState, useRef } from 'react'
import { CounterContext } from 'redux/Golbalvalues'
import styled from 'styled-components'
import '../../styleLess/signature/Taskinbox.scss'
import '../../styleLess/signature/new-status-styles.scss'
import { getHistoryInbox } from '../../api/TaskInbox/taskInboxapi'
import loadingSvg from 'icons/robot1.svg'
import loadingAnimationSvg from 'icons/three-dots.svg'
import { useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Button, DatePicker, Form, Input, Row, Select } from 'antd'
import moment from 'moment'
import { getCookie, removeCookie, setCookie } from '../../helper/cookie'
import { getPermissionControl } from 'api/Admin/rolePermission'
import { GET_DATA_ACCOUNT_BY_ID } from 'api/Account/profile'
const { RangePicker } = DatePicker
// canchange
import {
  CalendarOutlined,
  InboxOutlined,
  RedoOutlined,
  RightOutlined,
  SearchOutlined,
  TagsFilled,
} from '@ant-design/icons'

import { Layout } from 'antd'
import {
  getCompanyLink,
  getCompanyWithLink,
  getCompanyWithLinkV2,
} from 'api/MasterData/userManagement'
import { getResultCompanyById } from 'api/MasterData/company'
const { Header, Content } = Layout
const initalState = {
  data: [],
  isLoading: true,
  optioncompany_link: [
    {
      value: 0,
      label: 'All Company',
    },
  ],
}
const Collapes = styled.div``
let searchtext = ''

const History = () => {
  const dataCookieFilter = getCookie('historyInbox_filter')
  const dataCookie = eval('(' + dataCookieFilter + ')')
  const [dateSearch, setDateSearch] = useState()
  const [arrayList, setarrayList] = useState([])
  const [showCollapes, setshowCollapes] = useState(true)
  const [iconRB, seticonRB] = useState(true)

  const [optionlistCompanyLink, setOptionListCompanyLink] = useState(
    initalState.optioncompany_link,
  )
  const [companySelect, setCompanySelect] = useState(
    dataCookie?.company_id
      ? dataCookie?.company_id.split(',').length > 1
        ? 0
        : Number(dataCookie?.company_id)
      : 0,
  )
  const [dataAccount, setDataAccount] = useState(null)
  const { setPathActive, mainRoleUser } = useContext(CounterContext)
  const [dataHistory, setDataHsitory] = useState(initalState.data)
  const [render, setRender] = useState(1)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const userID = getCookie('userID')
  const roleUser = getCookie('roleUser')
  const passwordInput = useRef(null)
  const [readySearch, setReadySearch] = useState(true)
  const [dataFirst, setDataFirst] = useState(true)
  const [form] = Form.useForm()

  const getAccountCompanyOption = (accountData) => {
    if (!accountData?.company_id || !accountData?.companyname_en) {
      return null
    }
    return {
      value: Number(accountData.company_id),
      label: String(accountData.companyname_en),
    }
  }

  const mergeAccountCompanyOption = (options, accountData, companyByIDData) => {
    const accountOption = getAccountCompanyOption(accountData)
    if (!accountOption) {
      return options
    }

    const accountCompanyId = Number(accountOption.value)
    const companyById = Number(companyByIDData?.id)
    const isInactiveAccountCompany =
      accountCompanyId === companyById &&
      String(companyByIDData?.status || '').toLowerCase() === 'inactive'

    const optionsWithoutAccountCompany = options.filter(
      (item) => Number(item.value) !== accountCompanyId,
    )

    if (isInactiveAccountCompany) {
      return optionsWithoutAccountCompany
    }

    const isAlreadyExists = optionsWithoutAccountCompany.some(
      (item) => Number(item.value) === accountOption.value,
    )
    if (isAlreadyExists) {
      return optionsWithoutAccountCompany
    }
    return [...optionsWithoutAccountCompany, accountOption]
  }

  const [quarterState, setQuarterstate] = useState({
    start: null,
    end: null,
  })
  const GetAccountByID = () => {
    GET_DATA_ACCOUNT_BY_ID({
      token: token,
      id: parseInt(userID),
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataAccount(data)
          setIsLoading(false)
        } else {
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token && userID) {
      GetAccountByID()
    }
  }, [token , userID])


  const [dataCompanyByID, setDataCompanyByID] = useState(null)
  const fetchCompanyByIDV2 = async ({ companyID }) => {
    if (!companyID) return

    try {
      const response = await getResultCompanyById({
        id: companyID,
        token,
      })
      const { status, data, error } = response || {}

      if (error || status !== 200) return

      setDataCompanyByID(data)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    if (dataAccount?.company_id) {
      fetchCompanyByIDV2({ companyID: dataAccount.company_id })
    }
  }, [dataAccount])

  const getQuarter = () => {
    var today = new Date()
    var datenow =
      today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    var currentDate = moment(datenow).format('YYYY-MM-DD')
    const myArray = currentDate.split('-')
    let month = parseInt(myArray[1])
    if ([1, 2, 3].includes(month) && !dataCookie) {
      // This is a quarter one January -> March

      setQuarterstate((prev) => ({
        ...prev,
        start: `${myArray[0]}-1-01`,
        end: `${myArray[0]}-3-31`,
      }))
    } else if ([4, 5, 6].includes(month) && !dataCookie) {
      // This is a quarter two April -> June

      setQuarterstate((prev) => ({
        ...prev,
        start: `${myArray[0]}-4-01`,
        end: `${myArray[0]}-6-30`,
      }))
    } else if ([7, 8, 9].includes(month) && !dataCookie) {
      // This is a quarter three July -> September

      setQuarterstate((prev) => ({
        ...prev,
        start: `${myArray[0]}-7-01`,
        end: `${myArray[0]}-9-30`,
      }))
    } else if ([10, 11, 12].includes(month) && !dataCookie) {
      //This is a quarter four October -> December

      setQuarterstate((prev) => ({
        ...prev,
        start: String(`${myArray[0]}-10-01`),
        end: String(`${myArray[0]}-12-31`),
      }))
    } else if (dataCookie) {
      setQuarterstate((prev) => ({
        ...prev,
        start: dataCookie.start_date,
        end: dataCookie.end_date,
      }))
    }
  }
  const fetchCompanyForfiltering = async () => {
    // await getCompanyWithLink({
    await getCompanyWithLinkV2({
      token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataCompany([])
          return true
        }

        if (status === 200) {
          const mapping_CompanyLink = data?.map((item) => {
            return {
              value: item.id,
              label: item.name_en,
              // name_th: item.name_th,
            }
          })
          const baseCompanyOptions = [
            {
              value: 0,
              label: 'All Business',
              // name_th: 'ทั้งหมด',
            },
            ...mapping_CompanyLink,
          ]
          const groupArrayCompany = mergeAccountCompanyOption(
            baseCompanyOptions,
            dataAccount,
            dataCompanyByID,
          )
          setOptionListCompanyLink(groupArrayCompany)
        }
      })
      .catch((error) => {
        setDataCompany([])
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getQuarter()
      fetchCompanyForfiltering()
    }
  }, [token])

  useEffect(() => {
    setOptionListCompanyLink((prev) =>
      mergeAccountCompanyOption(prev, dataAccount, dataCompanyByID),
    )
  }, [dataAccount, dataCompanyByID])

  const getPermission = async () => {
    let checkRead = false
    await getPermissionControl({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (roleUser == 1) {
          checkRead = true
        }
        if (error) {
          return true
        }
        if (status === 200) {
          data.result?.permission?.map((item) => {
            if (item.menu_id == 21) {
              checkRead = true
            }
          })
          checkRead ? _ : history.push(`/no-permission`)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      setPathActive('/historyInbox')
      getPermission()
    }
  }, [token])

  useEffect(() => {
    if (dataHistory.length > 1 && dataCookieFilter && dataFirst) {
      if (dataCookie?.search) {
        BigSearch(dataCookie?.search)
      }
      setDataFirst(false)
    }
  }, [dataHistory, dataCookie])

  const Fetch_HistoryData = async () => {
    let start = ''
    let end = ''
    if (dateSearch != undefined) {
      start = quarterState?.start
      end = quarterState?.end
    } else {
      start = quarterState?.start
      end = quarterState?.end
    }

    const getAllIDcompany = optionlistCompanyLink
      .filter((item) => item.value !== 0)
      .map((i) => {
        return i.value
      })
      .join(',')
    const dataHistory = {
      search: '', //   <--- Search Front End
      start_date: start, // <--- Search Back End
      end_date: end, // <--- Search Back End
      company_id: companySelect == 0 ? getAllIDcompany : String(companySelect), // <--- Search Back End
    }

    await getHistoryInbox({
      token: token,
      params: dataHistory,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataHsitory([])
          return true
        }
        if (status === 200) {
          setIsLoading(false)
          setDataHsitory(data)
          setReadySearch(!readySearch)
        } else {
          setIsLoading(false)
          setDataHsitory([])
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        setDataHsitory([])
        console.error(error)
      })
  }

  useEffect(() => {
    setPathActive('/historyInbox')
    if (token) {
      if (quarterState.start != null && quarterState.end != null) {
        Fetch_HistoryData()
      }
    }
  }, [token, quarterState])
  useEffect(async () => {
    if (dataHistory.length != 0) {
      if (dataCookie?.search) {
        BigSearch(dataCookie?.search)
      } else {
        BigSearch(searchtext)
      }
    }
  }, [readySearch, searchtext])

  const EventIcontoUse = (data) => {
    let Focus = 0
    for (var i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id == data.id) {
        Focus = data.id
      }
    }
    if (data.subtask != null) {
      return (
        <RightOutlined
          className={iconRB && Focus ? 'RightOutlined' : 'active-RightOutlined'}
          onClick={() => handleshowCollapes(data)}
        />
      )
    } else if (data.subtask == null) {
      return <RightOutlined className="null-event-Icons" />
    }
  }
  const ReturnForonClicktitle = (data, item) => {
    return (
      <Row className="row-title-for-onclick">
        <div style={{ display: 'grid' }}>
          <h5
            className="onclick-open cutter-text-line-1"
            onClick={() => DetailTask(data, item.id, item.id, item)}
          >
            {item.title}
          </h5>
        </div>
      </Row>
    )
  }

  const handleshowCollapes = (data) => {
    WriteId(data.id)
  }
  const WriteId = (id) => {
    setarrayList([
      ...arrayList,
      {
        id: id,
      },
    ])
    ShowandHidden(id)
  }

  const ShowandHidden = (id) => {
    var addData = 0
    for (var i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id == id) {
        addData = id
      }
    }
    if (addData == id) {
      handleRemove(id)
    } else if (addData != id) {
      setshowCollapes(true)
      seticonRB(true)
    }
  }

  const handleRemove = (id) => {
    const newTag = arrayList.filter((item) => item.id !== id)
    setarrayList(newTag)
  }

  const resetFilter = () => {
    if (dataCookie) {
      form.setFieldsValue({ inputTest: '' })
      searchtext = ''
      removeCookie('historyInbox_filter')
      Fetch_HistoryData()
      window.location.reload()
    }
  }
  const renderContent = (data) => {
    if (render === 1) {
      return (
        <Layout className="layout-taskinbox">
          <Helmet>
            <title>AXONS PROJECT | History</title>
          </Helmet>
          <Header
            className="header-responsive-history"
            style={{ margin: 0, padding: 0, marginBottom: '34px' }}
          >
            <h1 className="no-breadcrumb" style={{ marginBottom: '24px' }}>
              History
            </h1>
            <div className="history-filter-content">
              <Input
                className="Search with-Taskbox history-repair-style"
                placeholder="Project name,Task and sub task name"
                disabled={isLoading}
                onChange={onChangeSearch}
                style={{ marginRight: '16px' }}
                allowClear
                size="large"
                defaultValue={dataCookie?.search}
              />
              <Select
                className="select-company-history"
                style={{ marginRight: '16px', width: '250px' }}
                size="large"
                onChange={(e) => setCompanySelect(e)}
                value={companySelect}
                options={optionlistCompanyLink}
              />
              <RangePicker
                className="range-picker-history"
                onChange={(e) => onChangeDate(e, 'main')}
                size="large"
                style={{ marginRight: 8 }}
                disabled={isLoading}
                allowClear={false}
                value={[
                  quarterState?.start === null ? null : moment(quarterState?.start),
                  quarterState?.end === null ? null : moment(quarterState?.end),
                ]}
              />

              <Button
                type="primary"
                className="BTN_Next"
                onClick={() => goSearch_History()}
              >
                <SearchOutlined className="Icon-color" />
                Search
              </Button>
              <Button
                type="primary"
                className="mini-search-btn-admin-reset"
                style={{ width: '99px', height: '42px', marginLeft: '16px' }}
                onClick={() => resetFilter()}
              >
                <RedoOutlined className="Icon-color" style={{ color: '#294f9f' }} />
                Reset
              </Button>
            </div>
          </Header>
          <Content className="Bodier" style={{ margin: 0 }}>
            {firstContentplay()}
          </Content>
        </Layout>
      )
    } else {
      return (
        <Layout>
          <Helmet>
            <title>AXONS PROJECT | Task Inbox</title>
          </Helmet>
          <Header className="header-responsive-taskinbox">
            <h1>Task Inbox</h1>
          </Header>
          <Bodier className="Bodier">
            <div className="empty-taskbox">
              <img className="img-emptystate" src={bin}></img>
              <h1>No Data</h1>
            </div>
          </Bodier>
        </Layout>
      )
    }
  }
  const firstContentplay = () => {
    if (isLoading === false) {
      if (dataHistory.length != 0) {
        return dataHistory.map((item) => {
          let j = 0

          if (item.task != undefined || item.task != null) {
            j = item.task.length
          }
          if (j !== 0) {
            return (
              <Collapes className="Collapes">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'grid', maxWidth: '60%' }}>
                    <h3 className="cutter-text-line-1 ">{item.title}</h3>
                  </div>

                  <h3>({j})</h3>
                </div>

                {renderMasterTask(item)}
              </Collapes>
            )
          }
        })
      } else {
        return (
          <div className="no-data-state-task-inbox">
            <InboxOutlined className="icon" />
            <h2>No data or not found Task and subtask</h2>
          </div>
        )
      }
    } else {
      return (
        <div
          className="taskInbox-style"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <img className="robot" src={loadingSvg}></img>
          <img src={loadingAnimationSvg} style={{ marginTop: 16 }}></img>
        </div>
      )
    }
  }
  const renderMasterTask = (data) => {
    if (data.task !== null && data.task !== undefined) {
      return data.task.map((item) => {
        let number = 0
        if (item.subtask !== null && item.subtask !== undefined) {
          number = item.subtask.length
        }

        let Focus = 0
        for (var i = 0; i < arrayList.length; i++) {
          if (arrayList[i].id == item.id) {
            Focus = item.id
          }
        }

        return (
          <div className="Master-Collapes">
            <div className="Container-master">
              <div
                className={`tab-color-follow  ${
                  item.flow_status === 'Not start'
                    ? 'status-not-start'
                    : item.flow_status === 'Complete'
                      ? 'status-complete'
                      : item.flow_status === 'On time'
                        ? 'status-on-time'
                        : item.flow_status === 'Delay'
                          ? 'status-delay'
                          : item.flow_status === 'On hold'
                            ? 'status-on-hold'
                            : 'status-hold'
                }`}
              ></div>
              <div className="MRML-Responsive">
                <div className="M-R-container">
                  {EventIcontoUse(item)}

                  <TagsFilled className="TagsFilled" />
                  <h5 className="code">{item.code}</h5>
                  <div
                    className={`Status  ${
                      item.flow_status === 'Not start'
                        ? 'status-not-start'
                        : item.flow_status === 'Complete'
                          ? 'status-complete'
                          : item.flow_status === 'On time'
                            ? 'status-on-time'
                            : item.flow_status === 'Delay'
                              ? 'status-delay'
                              : item.flow_status === 'On hold'
                                ? 'status-on-hold'
                                : 'status-hold'
                    }`}
                    style={{ minWidth: 'fit-content' }}
                  >
                    <span className="smallStatus ">{item.flow_status}</span>
                  </div>
                  <span className="small tasknumber">{number} subtasks</span>
                  <div className="block-box">{ReturnForonClicktitle(data, item)}</div>
                </div>
                <div className="M-L-container">
                  <CalendarOutlined className="CalendarOutlined"></CalendarOutlined>
                  <p>
                    {moment(item.plan_start).format('DD/MM/YYYY')} - {''}
                    {moment(item.plan_end).format('DD/MM/YYYY')}
                  </p>
                  <div className=" small tasknumber-responsive">
                    <div className="point"></div> {number} subtasks
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                showCollapes && Focus ? 'Showsub-collapes' : 'active-Showsub-collapes'
              }
            >
              {renderSubTask(data, item.id, item.subtask)}
            </div>
          </div>
        )
      })
    }
  }
  const renderSubTask = (dataProject, sprintflowId, data) => {
    if (data != null) {
      return data.map((item, index) => {
        return (
          <div className="Container-subitem ">
            <div className="a-container">
              <div className="reverse-container-responsive">
                <div>
                  <p className="cutter-text-line-1">{item.code}</p>
                </div>
                <div
                  className={`Status  ${
                    item.flow_status === 'Not start'
                      ? 'status-not-start'
                      : item.flow_status === 'Complete'
                        ? 'status-complete'
                        : item.flow_status === 'On time'
                          ? 'status-on-time'
                          : item.flow_status === 'Delay'
                            ? 'status-delay'
                            : item.flow_status === 'On hold'
                              ? 'status-on-hold'
                              : 'status-hold'
                  }`}
                >
                  <span className="smallStatus "> {item.flow_status} </span>
                </div>
              </div>
              <div style={{ display: 'grid', maxWidth: '60%' }}>
                <p
                  className="topic gotonextpage cutter-text-line-1 "
                  onClick={() => DetailTask(dataProject, sprintflowId, item.id, item)}
                >
                  {item.title}
                </p>
              </div>
            </div>
            <div className="b-container">
              <CalendarOutlined className="CalendarOutlined" />
              <p>
                {moment(item.plan_start).format('DD/MM/YYYY')} -{' '}
                {moment(item.plan_end).format('DD/MM/YYYY')}
              </p>
            </div>
          </div>
        )
      })
    }
  }
  const onChangeSearch = (e) => {
    searchtext = e.target.value
  }
  const goSearch_History = async () => {
    let start = ''
    let end = ''
    if (dateSearch != undefined) {
      start = quarterState?.start
      end = quarterState?.end
    } else {
      start = quarterState?.start
      end = quarterState?.end
    }
    const getAllIDcompany = optionlistCompanyLink
      .filter((item) => item.value !== 0)
      .map((i) => {
        return i.value
      })
      .join(',')
    const dataToCookie = {
      search: searchtext, //   <--- Search Front End
      start_date: start, // <--- Search Back End
      end_date: end, // <--- Search Back End
      company_id: companySelect == 0 ? getAllIDcompany : String(companySelect), // <--- Search Back End
    }
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    setCookie('historyInbox_filter', dataToCookie, { expires: expirationDate })

    setIsLoading(true)
    Fetch_HistoryData()
  }
  const onChangeDate = (date, type) => {
    if (date !== null) {
      if (type === 'main') {
        setQuarterstate((prev) => ({
          ...prev,
          start: moment(date[0]).format('YYYY-MM-DD'),
          end: moment(date[1]).format('YYYY-MM-DD'),
        }))
      }
    } else {
      setDateSearch(undefined)
    }
  }

  const BigSearch = async (value) => {
    //                            LEVEL 1
    await setDataHsitory([
      ...dataHistory,
      dataHistory.map((item) => {
        if (item?.title?.toLowerCase().includes(value.toLowerCase())) {
        } else {
          if (item.task != null) {
            let data = []

            item.task.map((item) => {
              if (item?.title?.toLowerCase().includes(value.toLowerCase())) {
                if (item.subtask != null) {
                  setarrayList((prev) => [...prev, { id: item.id }])
                }
                data.push(item)
              } else {
                if (item.subtask != null) {
                  let data = []
                  let count = 0
                  let length_subtask = item.subtask.length
                  item.subtask.map((item) => {
                    if (item?.title?.toLowerCase().includes(value.toLowerCase())) {
                      data.push(item)
                    } else {
                      count = count + 1
                      if (length_subtask == count) {
                        data = null
                      }
                    }
                  })
                  item.subtask = data
                }
              }
            })
          }
        }
      }),
    ])

    const newdata = dataHistory.filter((item) => item != undefined)
    await setDataHsitory(newdata)
    //                            LEVEL 3
    await setDataHsitory([
      ...dataHistory,
      dataHistory.map((item) => {
        if (item?.title?.toLowerCase().includes(value.toLowerCase())) {
        } else {
          if (item?.task !== null) {
            let data = []
            let count = 0
            let length_task = item?.task?.length
            item?.task?.map((item) => {
              if (
                item?.subtask !== null ||
                item?.title?.toLowerCase().includes(value.toLowerCase())
              ) {
                data.push(item)
              } else {
                count = count + 1
                if (length_task == count) {
                  data = null
                }
              }
            })
            item.task = data
          }
        }
      }),
    ])
    const newdata2 = dataHistory.filter((item) => item != undefined)
    await setDataHsitory(newdata2)

    const newdata3 = dataHistory.filter((item) => item.task !== null)
    await setDataHsitory(newdata3)

    if (value === '') {
      setarrayList([])
      if (passwordInput.current) {
        passwordInput.current.focus()
      }
    }
    setIsLoading(false)
  }
  const history = useHistory()
  const DetailTask = (data, sprintflowId, id, item) => {
    history.push({
      pathname: `historyInbox/${data.project_id}/${id}/update`,
    })
    setCookie('permission_sprintflow', item.permission_id)
    setCookie('cando', item.cando)
  }
  return renderContent()
}
export default History
